import React from 'react';

export default class FieldWithoutAccessoryBar extends React.Component {
  constructor(props) {
    super(props);
    this.onTouchStart = this.onTouchStart.bind(this);
    this.onBlur       = this.onBlur.bind(this);
  }

  onTouchStart() {
    hideFormAccessoryBar(true);
  }

  onBlur(e) {
    hideFormAccessoryBar(false);

    if (this.props.onBlur)
      this.props.onBlur(e);
  }

  render() {
    return this.props.children({
      onTouchStart: this.onTouchStart,
      onBlur:       this.onBlur
    });
  }
}

export function hideFormAccessoryBar(value, callback) {
  const { Keyboard } = window;
  if (Keyboard && Keyboard.hideFormAccessoryBar)
    Keyboard.hideFormAccessoryBar(value, callback);
  else if (callback) // for android that has no hideFormAccessoryBar
    callback(false);
}
